export default [
  {
    path: '*',
    name: 'topic',
    component: () => import('@/view/topic/index.vue'),
    meta: {
      title: '爱奇艺知识'
    }
  }
]
